import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Configuration Firebase - À remplacer par vos vraies clés
const firebaseConfig = {
    apiKey: "AIzaSyCLtOiBsIuURkYnLKGE-MvB4N4kmYqyPC0",
    authDomain: "ov-hairstyle.firebaseapp.com",
    projectId: "ov-hairstyle",
    storageBucket: "ov-hairstyle.firebasestorage.app",
    messagingSenderId: "855291318908",
    appId: "1:855291318908:web:d494cf34705c16228f6ff9",
    measurementId: "G-V0GEGQY2FT"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Initialiser les services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
